import { call, put, takeEvery } from 'typed-redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

import DashboardGateway from '~apis/dashboard';
import combinedActions from '~redux/combinedActions';

import { store } from '~redux/store';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TUpdateDashboarddMarketParams } from '~types/feat/dashboard';
import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { toast } from 'react-toastify';

export default function* watchOpenDashboardMarket(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardOpenDashboardMarketAttempt', handleOpenDashboardMarket, api);
}

function* handleOpenDashboardMarket(api: DashboardGateway, action: PayloadAction<TUpdateDashboarddMarketParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { branchCode } = action.payload;

    const response = yield* call([api, api.openDashboardMarket], {
        authToken,
        branchCode,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardOpenDashboardMarketFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardIsMarketStatusOpenConfimationModalOpen(false));
        toast.success(SuccessMessages.MarketStatusOpenSuccess);
        yield put(combinedActions.goldGetBranchMarketStatusAttempt({ branchCode }));
        yield put(combinedActions.dashboardOpenDashboardMarketSuccess(response.data));
    }
}
